// @flow

import { capitalize, escape, flow } from 'lodash';

import { singular } from '@zapier/common-utils';

import { NEW_SERVICE_FIELD } from 'app/developer-v3/utils/constants';

/**
 * Escapes the provided string
 *
 * @param {string} value
 */
export const makeTextHtmlSafe = (value: string): string =>
  escape(String(value));

export const getSettingsSaveText = (key: string) =>
  key === NEW_SERVICE_FIELD ? 'Save and Continue' : 'Save';

/**
 * Escapes the given string and for every line break, adds a br tag
 *
 * @param {string} value
 */
export const convertPlainTextToHtml = (value: string): string =>
  makeTextHtmlSafe(value)
    .split('\n')
    .join('<br />');

export const titleize = flow(singular, capitalize);
